import ErrorBoundary from "components/error-boundary";
import { IMaterialGroup } from "../type-definitions";
import NoAssigneeRhsContent from "./no-assignee-rhs-content";

interface ExcludedMaterialsRhsContentProps {
  completedWorkflowGroup: IMaterialGroup | null | undefined;
  unassignedGroup: IMaterialGroup | null | undefined;
  inactiveUserGroup: IMaterialGroup | null | undefined;
  unregisteredGroup: IMaterialGroup | null | undefined;
}

function ExcludedMaterialsRhsContent({
  completedWorkflowGroup,
  unassignedGroup,
  inactiveUserGroup,
  unregisteredGroup
}: ExcludedMaterialsRhsContentProps) {
  return (
    <div className="space-y-8" data-testid="excluded-materials-content">
      {completedWorkflowGroup && (
        <ErrorBoundary>
          <NoAssigneeRhsContent
            key={completedWorkflowGroup.groupId}
            title="Materials with Completed Workflow"
            group={completedWorkflowGroup}
            data-testid="completed-workflow-content"
          />
        </ErrorBoundary>
      )}

      {unassignedGroup && (
        <ErrorBoundary>
          <NoAssigneeRhsContent
            key={unassignedGroup.groupId}
            title="Materials without Subcontractor Assigned"
            group={unassignedGroup}
            data-testid="no-assignee-content"
          />
        </ErrorBoundary>
      )}

      {inactiveUserGroup && (
        <ErrorBoundary>
          <NoAssigneeRhsContent
            key={inactiveUserGroup.groupId}
            title="Materials with an Inactive Subcontractor Assigned"
            group={inactiveUserGroup}
            data-testid="inactive-assignee-content"
          />
        </ErrorBoundary>
      )}

      {unregisteredGroup && (
        <ErrorBoundary>
          <NoAssigneeRhsContent
            key={unregisteredGroup.groupId}
            title="Materials with an Unregistered Subcontractor Assigned"
            group={unregisteredGroup}
            data-testid="unregistered-assignee-content"
          />
        </ErrorBoundary>
      )}
    </div>
  );
}

export default ExcludedMaterialsRhsContent;
